module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (sources) { ;
__p += '\n    <div class="source-container">\n        <div class="library-source-container sorting-tabs">\n            ';
 sources.forEach(function(source) { ;
__p += '\n                <span data-source="' +
__e( source.name ) +
'">' +
__e( source.title ) +
'</span>\n            ';
 }) ;
__p += '\n            <div class="justify-empty-space"></div>\n        </div>\n    </div>\n';
 } ;
__p += '\n\n';
 if (filterAttributes) { ;
__p += '\n    <select class="filter-attribute form-control">\n        ';
 _.each(filterAttributes, function (text, value) { ;
__p += '\n            <option value="' +
__e( value ) +
'">' +
__e( text ) +
'</option>\n        ';
 }) ;
__p += '\n    </select>\n';
 } ;
__p += '\n\n<input class="content-filtering" type="search" placeholder="Search" maxlength="200">\n\n';
 if (sorting) { ;
__p += '\n    <div class="sorting-tabs">\n        ';
 sorting.forEach(function(sort) { ;
__p += '\n            <span data-sort="' +
__e( sort.name ) +
'">' +
__e( sort.title ) +
'</span>\n        ';
 }) ;
__p += '\n        ';
 if(isScene7) { ;
__p += '\n            <div class="justify-sorting-empty-space"></div>\n        ';
 } ;
__p += '\n    </div>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/common/SortingPanel.tpl
// module id = 1741
// module chunks = 0